<template>
  <v-card max-width="640" v-show="widgetloaded">
    <div v-if="wolfload" class="wolfload-time">
      <div class="blackbox">
        <svg
          width="100%"
          height="100%"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
          class="lds-dual-ring"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            stroke-linecap="square"
            r="40"
            stroke-width="16"
            stroke="rgba(0, 0, 0, 0.50)"
            stroke-dasharray="62.83185307179586 62.83185307179586"
            transform="rotate(359.669 50.0012 50.0012)"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              calcMode="linear"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
              dur="0.4s"
              begin="0s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>
    </div>
    <v-card-title class="headfirst title">
      <span class="branch-name">{{ salonhubInfo.salon.name }}</span>
      <!-- <v-divider style="border: none !important;"></v-divider> -->
      <v-select
        class="languageSelect .float-right"
        style="position: absolute; width: 54px; right: 50px; top: 8px;"
        :items="languages"
        v-model="selectedLanguage"
        item-text="item"
        dense
      >
        <template slot="selection" slot-scope="data">
          <country-flag :country="data.item.flag" />
          <!-- {{ data.item.lang }} -->
        </template>
        <template slot="item" slot-scope="data">
          <country-flag :country="data.item.flag" size="small" />
          {{ data.item.lang }}
        </template>
      </v-select>
      <div style="position: absolute; width: 54px; right: 0px; top: 9px;">
        <v-icon v-if="!closedWithFeedback" large class="close" @click="closeDialog()">mdi-close</v-icon>
        <v-icon v-if="closedWithFeedback" class="close" large @click="fullyClosed()">mdi-close</v-icon>
      </div>
    </v-card-title>

    <div  v-if="debug" class="pa-1 pr-0" style="background-color: #000; height: 130px; overflow: hidden;">
      <div v-if="debugLog.length > 0">
        <div class="text-center">
          <v-btn x-small @click="debugLog = new Array()">Wissen</v-btn>
        </div>
        <div id="debug-logs" class="pr-4" style="height: 100px; overflow: scroll;">
          <v-alert
            class="pa-0 ma-1"
            v-for="(log, index) in debugLog" :key="index"
            dense
            outlined
            :type="log.type"
            >
            {{ log.time }} - {{ log.log}}
          </v-alert>
        </div>
        
      </div>
      
      <div v-else style="color: #fff; text-align: center; font-weight: bold; padding: 50px 0;">
        Geen debug logs
      </div>
    </div>

    <!-- Emergency -->

    <v-card-text
      v-if="salonhubInfo.settings.emergency.enabled == true"
      style="padding: 0 0 0 0 !important; overflow: hidden;"
    >
      <v-card-title style="color: red;">{{ salonhubInfo.settings.emergency.title }}</v-card-title>

      <v-card-text v-html="salonhubInfo.settings.emergency.contents"></v-card-text>

      <!-- <v-btn large style="margin: 0 0 24px 12px; width: 500px;" class="mr-4" @click="fullyClosed()">Sluiten</v-btn> -->
    </v-card-text>

    <!-- Stepper Start -->
    <v-card-text
      v-if="!closedWithFeedback && salonhubError == false && salonhubInfo.settings.emergency.enabled == false"
      style="padding: 0 0 0 0 !important; overflow: hidden;"
    >
      <v-stepper class="stepcontent" v-model="step" alt-labels>
        <div class="stickySteps">
          <v-stepper-header>
            <v-stepper-step
              style="font-size: 11px;"
              v-for="(theStep, index) in stepOrder"
              :key="index"
              :step="theStep.id"
              :complete="stepIndex > theStep.id"
            >{{ $t(`${theStep.name}`) }}</v-stepper-step>
          </v-stepper-header>

          <div v-if="stepIndex !== 7" class="stickyTitle" style="margin: 12px 0 0 12px;">
            <span class="display-1 text--primary">{{ stepIndex }}</span>
            {{ $t(step + "desc") }}
            <hr />
          </div>
        </div>

        <div
          :style="
            stepIndex == 7
              ? 'position: relative; z-index: 800; margin: 2px 0 0 0;'
              : 'position: relative; z-index: 800; margin: 2px 0 0 0;'
          "
        >
          <v-stepper-items style="overflow-y:scroll;" :style="{ maxHeight: stepperHeight }">
            <v-stepper-content step="treatment" v-if="treatments.length !== 0">
              <div style="margin: 0 12px 12px 0; padding: 0 0 16px 0; width: 100%; background-color:#fff;" v-if="!multipleTreatmentsByParam || multipleTreatmentsByParam.length == 0">
                <div v-if="salonhubInfo.settings && salonhubInfo.settings.treatmentGroups && salonhubInfo.settings.treatmentGroups.length > 0">
                  <v-slide-group
                      v-model="selectedGender"
                      class="pa-0 ma-0"
                      mandatory
                      show-arrows
                      >
                      <v-slide-item
                        v-for="(group, index) in salonhubInfo.settings.treatmentGroups"
                        :key="index"
                        :value="group.id"
                        v-slot="{ active, toggle }"
                        >
                        <v-btn
                          class="mx-1 my-0"
                          :input-value="active"
                          active-class="primary--text"
                          depressed
                          @click="toggle"
                        >
                         <div style="text-transform: uppercase"><strong>{{ group.name }}</strong></div>
                        </v-btn>
          
                      </v-slide-item>
                    </v-slide-group>
                </div>
                <div v-else>
                  <v-btn-toggle v-model="selectedGender" color="primary">
                    <v-btn value="female">
                      <span>{{ $t("basicdictionary.female") }}</span>
                    </v-btn>
                    <v-btn value="male">
                      <span>{{ $t("basicdictionary.male") }}</span>
                    </v-btn>
                    <v-btn value="child">
                      <span>{{ $t("basicdictionary.kids") }}</span>
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </div>

              <v-card style="margin:12px 0 0 0;" flat>
                <v-divider style="border: none !important;"></v-divider>
                <v-list dense subheader three-line v-model="selectedTreatmentIndex">
                  <v-list-item-group color="primary"  
                    v-for="(treatment, index) in treatments.treatments[selectedGender]"
                      :key="index"
                      :disabled="treatment.type == 'title' || treatment.type == 'text'"
                      :class="treatment.type"
                      style="min-height: 0px;"
                      class="my-1"
                      >
                    <!-- Treatment -->
                    <v-list-item v-if="treatment.type == 'treatment'" @click="selectTreatment(index, treatment)">
                      <template>
                        <v-list-item-content >
                          <v-list-item-title
                            :class="'' + ('go' + treatment.id)"
                            v-html="treatment.name"
                            class="ma-0 pa-0"
                          >
                            {{ treatment.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-html="treatment.description"></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action v-if="treatment.type == 'treatment' && showPrice == true && typeof treatment.price !== 'undefined'">
                          <v-list-item-action-text style="font-size: 14px; font-weight: bold">€ {{(treatment.price.value / 100 ).toFixed(2) }}</v-list-item-action-text>
                        </v-list-item-action>

                      </template>
                    </v-list-item>

                    <v-list-item disabled v-if="treatment.type == 'title' || treatment.type == 'text'" style="min-height: 0px!important;">

                      <!-- Message -->

                      <v-list-item-content class="pa-0 py-1" style="min-height: 0px!important;">
                        <div style="color: #1976d2;" class="treatment-title">
                          <strong>{{ treatment.name }}</strong>
                        </div>
                        <div class="treatment-description">
                        {{ treatment.description }}
                        </div>
                      </v-list-item-content>
                    </v-list-item>

                    <!-- warning -->
                    <v-list-item disabled style="min-height: 0;" class="px-0" v-if="treatment.type == 'message' && treatment.style == 'warning'">
                      <v-list-item-content class="pa-0 py-2 mx-0" style="min-height: 0!important;">

                        <v-alert
                          class="ma-0"
                          type="warning"
                          icon="mdi-information"
                          color="#e7ae1e"
                        >
                        <div class="text-h8">
                         <strong> {{ treatment.name }}</strong>
                        </div>
                        <div style="padding: 5px 0 0 0; font-size: 14px;">
                        {{ treatment.description }}
                        </div>
                        </v-alert>

                      </v-list-item-content>
                    </v-list-item>

                    <!-- info -->
                    <v-list-item disabled class="px-0" style="min-height: 0;" v-if="treatment.type == 'message' && treatment.style == 'info'">
                      <v-list-item-content class="pa-0 py-2" style="min-height: 0px!important;">
                        <v-alert
                          class="ma-0"
                          icon="mdi-information"
                          color="#dbebf8"
                        >
                        <div class="text-h8" style="color: #4f68ba">
                         <strong> {{ treatment.name }}</strong>
                        </div>
                        <div style="padding: 5px 0 0 0; font-size: 14px;">
                        {{ treatment.description }}
                        </div>
                        </v-alert>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item disabled class="px-0" v-if="treatment.type == 'section'">
                      <v-list-item-content class="pa-0 py-2">
                        <div class="text-h6" style="color: #4f68ba">
                         <strong> {{ treatment.name }}</strong>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="employee">
              <div class="toplist" style="margin:2px 0 0 0;">
                <v-card flat color="#1976d2" dark class="pa-4" v-if="treatmentByParamName">
                  <p style="font-size: 18px; margin: 0"><strong>{{ $t("chosenTreatment") }}: </strong> {{ treatmentByParamName }}</p>
                </v-card>
                <v-list>
                  <v-list-item-group color="primary" v-model="selectedEmployeeIndex">
                    <!-- Employee -->
                    <v-list-item
                      style=" border-bottom: 1px solid #dddddd;"
                      v-for="(employee, index) in employees"
                      :key="index"
                      :class="'employeelist ' + 'employee' + index"
                      @click="selectEmployee(employee.id, employee.name)"
                    >
                      <v-list-item-avatar size="50" v-if="employee.photo.length !== 0">
                        <img :src="employee.photo" />
                      </v-list-item-avatar>

                      <v-list-item-icon v-else>
                        <v-icon style="margin:0 -10px 0 0px; padding: 0 0 0 8px;" large>mdi-account</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content >
                        <v-list-item-title
                          style="line-height: 3.2;"
                          v-html="employee.name"
                        >{{ employee.name }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
            </v-stepper-content>

            <v-stepper-content step="date">
              <div class="toplistdate" style="margin:2px 0 0 0;">
                <v-list dense v-if="modifiedDate.length > 0">
                  <v-list-item-group color="primary">
                    <!-- Date -->
                    <v-list-item
                      v-for="(datestamp, index) in modifiedDate"
                      :key="index"
                      :class="datestamp.type"
                      :disabled="datestamp.type == 'group'"
                    >
                      <v-list-item-content @click="selectDate(datestamp.id, datestamp.name)">
                        <!-- {{ moment(datestamp).format("YYYY") }} -->
                        <v-list-item-title v-html="datestamp.name">{{ datestamp.name }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                    <div v-if="datesLoading" class="text-center my-2">
                      <v-progress-circular
                        class="mx-auto "
                        indeterminate
                        color="#1a62ca"
                      ></v-progress-circular>
                  </div>
                </v-list>


                <div v-else>
                  <div
                    id="dateNotAvailable"
                    style="color: rgb(214, 100, 0); background-color: rgb(249, 206, 86); margin: 12px 0 12px 0; padding: 12px;"
                    >{{ $t("dateNotFound") }}
                  </div>
                  <div class="py-3" v-if="showCallback">
                    <h3 class="text-center">{{ $t("call.textCallError") }}</h3>
                    <v-btn
                      v-if="!showCallbackButtonClicked"
                      class="mx-auto my-3"
                      large
                      block
                      style="width: 320px; min-width: 0!important"
                      color="success"
                      @click="callMe()"
                      :disabled="callClient"
                      >
                      <v-icon left>mdi-phone</v-icon>
                      {{ $t("call.callMe") }}
                    </v-btn>
                    <div v-else class="mx-3">
                      <v-alert
                        dense
                        text
                        type="success"
                      >
                      {{ $t("call.callAsked") }}
                      </v-alert>
                    </div>
                  </div>
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-content step="time">
              <div class="toplisttime" style="margin:2px 0 0 0;">
                <v-list dense v-if="times.length !== 0">
                  <v-list-item-group color="primary">
                    <!-- selectedTime = time.startHour + ':' + (time.startMinute < 10 ? '0' : '') + time.startMinute + ':00'; -->

                    <!-- Time -->
                    <v-list-item v-for="(time, index) in times" :key="index" class="time">
                      <v-list-item-content @click="selectTime(time)">
                        <v-list-item-title v-html="time + ' uur'"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <div v-else>
                  <div
                    id="dateNotAvailable"
                    style="color: rgb(214, 100, 0); background-color: rgb(249, 206, 86); margin: 12px 0 12px 0; padding: 12px;"
                    >{{ $t("dateNotFound") }}
                  </div>
                  <div class="py-3" v-if="showCallback">
                    <h3 class="text-center">{{ $t("call.textCallError") }}</h3>
                    <v-btn
                      v-if="!showCallbackButtonClicked"
                      class="mx-auto my-3"
                      large
                      block
                      style="width: 320px; min-width: 0!important"
                      color="success"
                      @click="callMe()"
                      :disabled="callClient"
                      >
                      <v-icon left>mdi-phone</v-icon>
                      {{ $t("call.callMe") }}
                    </v-btn>
                    <div v-else class="mx-3">
                      <v-alert
                        dense
                        text
                        type="success"
                      >
                      {{ $t("call.callAsked") }}
                      </v-alert>
                    </div>
                  </div>
                </div>
              </div>
            </v-stepper-content>

            <!-- Form Client -->
            <v-stepper-content step="clientInfo">
              <div style="margin: 0 0 12px 0;">

                <v-card flat color="#1976d2" dark class="pa-4 mb-4" v-if="treatmentByParamName">
                  <p style="font-size: 18px; margin: 0"><strong>{{ $t("chosenTreatment") }}: </strong> {{ treatmentByParamName }}</p>
                </v-card>
               
                <p style="padding: 0px 0px 0px 0px;">{{ $t("clientInfoExtradesc") }}</p>
                

                <v-form ref="form" v-model="valid" :key="formChanges">
                  <div class="privacypolicy" v-if="showPolicy && agreebox == false">
                    <v-textarea
                      style="pointer-events: visible !important;"
                      :value="policyLang"
                      disabled
                      filled
                      rows="7"
                    ></v-textarea>
                  </div>

                  <div class="inputForm" v-if="showPolicy == false || agreebox == true">
                    <v-text-field
                      filled
                      v-model="name"
                      :counter="30"
                      :rules="nameRules"
                      :label="$t('name')"
                      required
                    ></v-text-field>

                    <v-text-field
                      filled
                      v-model="email"
                      :rules="emailRules"
                      label="E-mail"
                      required
                    ></v-text-field>

                    <div class="d-flex">
                      <v-select
                        class="d-flex pr-2"
                        style="max-width:120px;"
                        filled
                        @change="testSven()"
                        :items="languagesPhone"
                        v-model="selectedPhoneLanguage"
                        item-text="item"
                      >
                        <template slot="selection" slot-scope="data">
                          <country-flag :country="data.item.flag" />
                          <span class="pl-2">{{ data.item.lang }}</span>
                        </template>
                        <template slot="item" slot-scope="data">
                          <country-flag :country="data.item.flag" size="small" />
                          <span class="pl-2">{{ data.item.lang }}</span>
                        </template>
                      </v-select>

                      <v-text-field
                        class="d-flex"
                        filled
                        v-model="tel"
                        :counter="12"
                        :rules="telRules"
                        :label="$t('telephone')"
                        required
                      ></v-text-field>
                    </div>
                  </div>
                  <v-card-text
                    v-show="agreeStorage == true"
                    class="pa-0"
                    style="margin-left:4px;"
                  >{{ $t("alreadyAgreed") }}</v-card-text>

                  <v-checkbox
                    class="ma-0 pa-0 agreebox"
                    v-model="agreebox"
                    :rules="checkRules"
                    required
                  
                  >
                    <template v-slot:label class="ma-0">
                      {{ $t("termsandconditions") }}
                      <a
                        style="margin-left:6px;"
                        href="#"
                        @click.stop.prevent="
                          showPolicy = !showPolicy;
                          agreebox = false;
                        "
                      >Privacy Policy</a>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    v-if="extraTermsUrl"
                    class="ma-0 pa-0 agreebox"
                    v-model="agreeboxExtra"
                    :rules="checkRules"
                    required
                  >
                    <template v-slot:label class="ma-0">
                    <span>
                      {{ $t("agreecustomterms") }}
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            :href="extraTermsUrl"
                            target="_blank"
                            @click.stop
                            v-on="on"
                          >
                          {{ $t("customtermsandconditions") }}</a>
                        </template>
                        {{ $t("agreecustomtermsnewwindow") }}
                      </v-tooltip>
                       {{ $t("customtermsandconditionsof") }} {{ salonhubInfo.salon.name }}.</span>
                    </template>
                  </v-checkbox>
                </v-form>
              </div>
            </v-stepper-content>

            <!-- Summary -->
            <v-stepper-content step="summary">
              <div
                v-if="confirmed == true"
                id="confirmed"
                style="color: #3c763d;; background-color: #dff0d8; margin: 12px 0 4px 0; padding: 12px 12px 12px 12px;"
              >{{ $t("confirmedMessage") }}</div>

              <div style="margin: 22px 0 12px 0;">
                <span style="font-size:18px; line-height:2.3em; color:#666;">
                  <v-icon style="padding-right:6px;">mdi-content-cut</v-icon>
                  {{ this.selectedTreatment.name }}
                </span>
                <br />
                <span style="font-size:18px; line-height:2.3em;">
                  <v-icon style="padding-right:6px;">mdi-clock-outline</v-icon>
                  {{ this.selectedDate.name }} om {{ selectedTime }} uur
                </span>
                <br />
                <span style="font-size:18px; line-height:2.3em;">
                  <v-icon style="padding-right:6px;">mdi-account</v-icon>
                  {{ this.selectedEmployee.name }}
                </span>
                <br />
                <span v-show="confirmed == true" style="font-size:18px; line-height:2.3em;">
                  <v-icon style="padding-right:6px;">mdi-phone</v-icon>
                  Tel. {{ salonhubInfo.salon.telephone }}
                </span>
                <br v-show="confirmed == true" />
                <span v-show="confirmed == true" style="font-size:18px; line-height:2.3em;">
                  <v-icon style="padding-right:6px;">mdi-email</v-icon>
                  <a :href="`mailto:` + salonhubInfo.salon.email">{{ salonhubInfo.salon.email }}</a>
                </span>
                <br v-show="confirmed == true" />
                <span v-show="confirmed == false" style="font-size:18px; ">
                  <v-icon style="padding-right:6px;">mdi-home</v-icon>
                </span>
                <small v-show="confirmed == false" style="font-size:14px;">
                  {{ salonhubInfo.salon.name }}
                  <span style="position: relative; left: 34px;">
                    <br />
                    {{ salonhubInfo.salon.postalcode }} {{ salonhubInfo.salon.city }}
                    <br />
                    {{ salonhubInfo.salon.address }}
                  </span>
                </small>

                <p v-show="confirmed == false" style="margin: 8px 0 0 0;">
                  {{ $t("confirmedMessageExtra1") }} {{ $t("confirmedMessageExtra2") }} {{ email }}
                </p>
                <p v-show="confirmed == true" style="margin: 8px 0 0 0;">{{ $t("anyQuestions") }}</p>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </div>
      </v-stepper>
    </v-card-text>
    <!-- End Stepper -->

    <v-card-text
      v-if="(closedWithFeedback || salonhubError == true) && salonhubInfo.settings.emergency.enabled == false"
      style="padding: 0 0 0 0 !important; overflow-y: scroll;"
    >
      <div v-if="closedWithFeedback && succesfullCall == false">
        <v-card-title style="display: block" class="text-center">{{ $t("call.titleCall") }}</v-card-title>
        
        <!-- <v-card-text style="display: block" class="text-center">{{ $t("call.textCall") }}</v-card-text> -->
      </div>

      <div v-if="salonhubError == true && succesfullCall == false">
        <v-card-title>{{ $t("call.titleCallError") }}</v-card-title>
        <v-card-subtitle>
          <strong>{{ $t("call.subtitleCall") }}</strong>
        </v-card-subtitle>
        <!-- <v-card-text>{{ $t("call.textCall") }}</v-card-text> -->
      </div>

      <div v-if="succesfullCall == true">
        <v-card-title style="color:#4caf50;">{{ $t("call.callSucces") }}</v-card-title>
        <v-card-subtitle>
          <strong>{{ $t("call.subtitleCall") }}</strong>
        </v-card-subtitle>
        <v-card-text>{{ $t("call.textCall") }}</v-card-text>
      </div>

      <div  v-if="showCallback">
        <p class="mx-2 text-center">{{ $t("call.textCallError") }}</p>
        <v-btn
        v-if="!showCallbackButtonClicked"
          class="mx-auto my-3"
          large
          block
          style="width: 320px; min-width: 0!important"
          color="success"
          @click="callMe()"
          :disabled="callClient"
          >
          <v-icon left>mdi-phone</v-icon>
          {{ $t("call.callMe") }}
        </v-btn>
        <div v-else class="mx-3">
          <v-alert
            dense
            text
            type="success"
          >
          {{ $t("call.callAsked") }}
          </v-alert>
        </div>
      </div>
      <div v-if="!salonhubError"   style="width: 320px; margin: 0 auto">
        <v-card-subtitle style="display: block" class="text-center pb-0">
          <strong>{{ $t("call.subtitleCall") }}</strong>
        </v-card-subtitle>
        <v-radio-group v-model="exitReason">
          <v-radio
            key="1"
            :label="$t('call.noSpaceFound')"
            value="noSpaceFound"
          ></v-radio>
          <v-radio
            key="2"
            :label="$t('call.restartingWidget')"
            value="restartingWidget"
          ></v-radio>
          <v-radio
            key="4"
            :label="$t('call.other')"
            value="other"
          ></v-radio>
          <v-textarea
            v-if="exitReason == 'other'" 
            outlined
            rows="3"
            v-model="customExitReason"
            background-color="#f1f1f1"
            hide-details
          >
          </v-textarea>
        </v-radio-group>

      <v-btn
        class="mx-auto mb-2"
        large
        block
        color="black"
        dark
        style="width: 320px; min-width: 0!important"
        @click="fullyClosed()"
      >{{ $t("call.close") }}</v-btn>
      </div>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <img
        class="poweredby"
        style="width:90px; height:30px; margin: 0 0 0 2px;"
        srcset="../img/hogans-2x.png 1x, ../img/hogans-1x.png 1x"
        src="../img/hogans-1x.png"
      />

      <v-spacer></v-spacer>

      <v-btn
        v-if="confirmed == false && !closedWithFeedback && salonhubInfo.settings.emergency.enabled == false"
        :disabled="stepIndex === 1 || wolfload == true"
        @click="stepBack()"
      >{{ $t("basicdictionary.back") }}</v-btn>
      <v-btn
        class="withdesktop"
        v-if="confirmed == true"
        @click="closeDialog()"
      >{{ $t("basicdictionary.close") }}</v-btn>
      <v-btn
        class="withdesktop"
        v-if="salonhubInfo.settings.emergency.enabled == true && salonhubInfo.settings.emergency.blocked == true"
        @click="fullyClosed()"
      >{{ $t("basicdictionary.close") }}</v-btn>
      <v-btn
        class="withdesktop"
        v-if="salonhubInfo.settings.emergency.enabled == true && salonhubInfo.settings.emergency.blocked == false"
        @click="salonhubInfo.settings.emergency.enabled = false"
        color="success"
      >
        {{ $t("basicdictionary.closeAlart") }}
        <v-icon>mdi-arrow-right-thick</v-icon>
      </v-btn>

      <!-- <v-btn
        class="withmobile"
        v-if="confirmed == true && userAgent == 'mobile'"
        @click="closePage()"
      >{{ $t("basicdictionary.close") }}</v-btn>-->

      <v-btn
        v-if="step == 'summary' && confirmed == false && docId == null"
        :disabled="wolfload"
        color="success"
        class="mr-4 withback"
        @click="
          clientDataForm('back');
          stepIndex++;
        "
      >
        {{ $t("basicdictionary.confirm") }}
        <v-icon>mdi-check-bold</v-icon>
      </v-btn>
      <v-btn
        v-if="step == 'summary' && confirmed == false && docId !== null"
        :disabled="wolfload"
        color="success"
        class="mr-4 noback"
        @click="
          clientDataForm(clientIntel);
          stepIndex++;
        "
      >
        {{ $t("basicdictionary.confirm") }}
        <v-icon>mdi-check-bold</v-icon>
      </v-btn>

      <!-- With Treatment Selection -->
      
      <v-btn
        :disabled="!valid"
        v-if="step === 'clientInfo' && skipTreatmentSelectById && salonhubInfo.settings.emergency.enabled == false"
        @click="
          setSelectedTreatmentData();  
        "
        color="success"
      >
        {{ $t("basicdictionary.next") }} 
        <v-icon>mdi-arrow-right-thick</v-icon>
      </v-btn>

      <v-btn
        :disabled="!valid"
        v-if="step === 'clientInfo' && treatmentByParam && selectedEmployeeIndex == 0  && salonhubInfo.settings.emergency.enabled == false"
        @click="step = stepOrder[2].name, stepIndex = stepIndex + 2;
          
          createClientDoc('byFront');
        "
        color="success"
      >
        {{ $t("basicdictionary.next") }} 
        <v-icon>mdi-arrow-right-thick</v-icon>
      </v-btn>
      <!-- without client info present -->
      <v-btn
        class="nodoc"
        :disabled="!valid"
        v-if="
          step === 'clientInfo' &&
            clientIntel == 'front' &&
            !closedWithFeedback &&
            !skipTreatmentSelectById &&
            !treatmentByParam &&
            salonhubInfo.settings.emergency.enabled == false
        "
        @click="
          createClientDoc('byFront');
          step = stepOrder[stepIndex++].name;
        "
        color="success"
      >
        {{ $t("basicdictionary.next") }} 
        <v-icon>mdi-arrow-right-thick</v-icon>
      </v-btn>
      <!-- without client info present -->
      <v-btn
        class="withdoc"
        :disabled="!valid"
        v-if="
          step === 'clientInfo' &&
            clientIntel == 'front' &&
            !closedWithFeedback &&
            docId !== null &&
            !treatmentByParam &&
            !skipTreatmentSelectById &&
            salonhubInfo.settings.emergency.enabled == false
        "
        @click="step = stepOrder[stepIndex++].name"
        color="success"
      >
        {{ $t("basicdictionary.next") }} 4
        <v-icon>mdi-arrow-right-thick</v-icon>
      </v-btn>
      <v-btn
        :disabled="!valid"
        v-if="step === 'clientInfo' && clientIntel == 'back' && !closedWithFeedback"
        @click="step = stepOrder[stepIndex++].name"
        color="success"
      >
        {{ $t("basicdictionary.next") }}
        <v-icon>mdi-arrow-right-thick</v-icon>
      </v-btn>

      <!-- <v-btn v-if="false" :disabled="true" color="primary" depressed @click="step++">Next</v-btn> -->
    </v-card-actions>
  </v-card>
</template>

<script>
import rateLimit from "axios-rate-limit";
import db from "../firebase/init";
import axios from "axios";
import CountryFlag from "vue-country-flag";
import moment from "moment";
import slugify from "slugify";
import { v4 as uuidv4 } from "uuid";
import phoneVal from "phone";
import uniqid from 'uniqid';

export default {
  name: "bookingEditComp",
  props: {
    companyId: String,
    activeBranch: String,
    salonhubname: String,
    lang: String,
    stepperHeight: String,
    stepperCardHeight: String,
    gender: String,
    clientIntel: String,
    clientOrder: String,
    treatmentByParam: String,
    treatmentByParamName: String,
    treatmentByParamPrice: Number,
    skipTreatmentSelectById: String,
    skipEmployeeSelectById: String,
    clientName: String,
    clientEmail: String,
    clientTel: String,
    showPrice: Boolean,
    multipleTreatmentsByParam: Array,
    src: String,
    startUrl: String,
    salonname: String,
    salonhubApiSettings: Object,
    url: String,
    succesUrl: String,
    userAgent: String,
    callcenter: Object,
    callTo: String,
    feedBackOnClose: Boolean,
    showCallback: Boolean,
    executedFrom: String,
    smsSettings: Object,
    extraTermsUrl: String,
    debug: Boolean,
    
    // callUrl: String,
    policy: Object,
    confirmMail: Boolean
  },
  components: { CountryFlag },

  data: function () {
    return {
    exitReason: null,
    showCallbackButtonClicked: false,
    configAxios: {
      headers: { Authorization: `Bearer b3b9dbb9-249a-4aac-9a94-5809beedcb1d` }
    },
    configAxiosPOST: {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer b3b9dbb9-249a-4aac-9a94-5809beedcb1d`
      }
    },
    salonhubInfo: {
      salon: { name: "Loading..." },
      settings: {
        emergency: {
          enabled: false
        }
      }
    },

    selectedLanguage: { lang: "NL", flag: "nl" },
    languages: [
      { lang: "NL", flag: "nl" },
      { lang: "BE", flag: "be" },
      { lang: "EN", flag: "us" }
    ],
    languagesPhone: [
      { lang: "+31", flag: "nl", phone: "NLD" },
      { lang: "+32", flag: "be", phone: "BE" },
      { lang: "+49", flag: "de", phone: "DE" },
      { lang: "+1", flag: "us", phone: "USA" },
      { lang: "+1", flag: "ca", phone: "CAN" },
      { lang: "+7", flag: "ru", phone: "RUS" },
      { lang: "Other", flag: "nl", phone: "Other" }
    ],
    policyLang: "",
    showPolicy: false,
    wolfload: false,
    widgetloaded: false,
    employeeFirst: false,
    salonhubError: false,
    succesfullCall: false,
    customExitReason: "",

    docId: null,
    stepOrder: [],
    step: "",
    stepIndex: 1,
    item: 1,
    multiple: false,
    eventSlotsCSS: false,
    bookingEditDialog: false,
    changeappointment: false,
    clientExist: false,
    closedWithFeedback: false,
    actionBy: "",
    showPolicy: false,

    callClient: false,
    callCounter: "",

    eventButton: false,
    selectedGender: "female",

    selectedGenderHuman: "Dames",
    storeData: false, //Store data
    treatments: {
      treatments: {
        //   female: [
        //     {
        //       type: "separator"
        //     },
        //     {
        //       name: "  ",
        //       description: "Specials",
        //       type: "message"
        //     },
        //     {
        //       id: 420,
        //       name: "All -In Kleur Menu Scandinavion Lightning",
        //       description: "modisch knippen & totale kleuring + kleurtechniek & condtioneren & stylen",
        //       price: {
        //         value: 19500,
        //         name: "€ 195,00"
        //       },
        //       length: 165,
        //       type: "treatment"
        //     }
        //   ]
      }
    },
    datesLoading: false,
    treatment: 1,
    seePrice: true,
    source: "",
    confirmed: false,

    employees: [],
    selectedTreatmentIndex: "", //For selecting Treatment
    selectedTreatment: {
      id: "",
      name: "",
      price: ""
    },
    selectedEmployeeIndex: 0, //For selecting Employee
    tempEpmloyeeID: null,
    selectedEmployee: {
      id: "",
      name: ""
    },
    selectedDate: {
      id: "",
      name: "",
      timestamp: null
    },
    selectedPhoneLanguage: { lang: "+31", flag: "nl", phone: "NLD" },
    selectedTime: "",
    dates: [],
    modifiedDate: [],
    dateMin: null,
    dateMax: null,
    times: [],
    name: "",
    nameRules: [
      v => !!v || this.$t("nameRequired"),
      v => (v && v.length <= 30) || this.$t("maxNameLength")
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || this.$t("emailRequired")
    ],
    tel: "",
    telTemp: "",
    telRules: [
      v => !!v || this.$t("phoneRequired"),
      // v => v.length > 8 || this.$t("phoneRequired"),
      // v => v.length > 7 || this.$t("phoneRequired"),
      v => ((this.selectedPhoneLanguage.flag != 'be' && v.length > 8)|| (this.selectedPhoneLanguage.flag == 'be' && v.length > 7)) || this.$t("phoneRequired"),
      v => /^[0-9+]*$/.test(v) || this.$t("phoneValid"),
    ],
    formChanges: 0,

    
    phone: "",
    checkRules: [v => !!v || this.$t("checkToContinue")],
    agreebox: false,
    agreeboxExtra: false,
    agreeStorage: false,
    valid: false, //Zijn persoongevens goed ingevuld?
    localStorageActive: false,
    debugLog: new Array(),
  }},

  

  created() {
    var console = {
      panel: $(parent.document.body).append('<div>'),
      log: function(m){
          this.panel.prepend('<div>'+m+'</div>');
      }       
    };
   
    this.localStorageActive = isLocalStorageNameSupported();

    // Check if LocalStorage is active Private browser
     function isLocalStorageNameSupported() {
      let testKey = 'test', storage = window.localStorage;
      try {
        storage.setItem(testKey, '1');
        storage.removeItem(testKey);
        console.log("LocalStorage Active")
        this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: 'LocalStorage Active'})

        return true;
      } catch (error) {
        console.log("LocalStorage Deactive")
        this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: 'LocalStorage Deactive'})
        return false;
      }
    }

    if (this.showPrice == 0) {
     this.seePrice = false;
      console.log("show Prices")
     }
     else {
      this.seePrice = true;
      console.log("hide prices")
     }
  },

  mounted() {
    //Google GTM 
    this.$gtm.trackView("widgetScreen", "widgetPath");

    if (this.lang) {
      if (this.lang.toLowerCase() == "nl") {
        this.selectedLanguage = { lang: "NL", flag: "nl" };
      }
      else if (this.lang.toLowerCase() == "be") {
        this.selectedLanguage = { lang: "BE", flag: "be" };
        this.selectedPhoneLanguage = { lang: "+32", flag: "be", phone: "BE"  }
      }
      else if (this.lang.toLowerCase() == "nl2") {
        this.selectedLanguage = { lang: "NL", flag: "nl" };
        this.$i18n.locale = 'NL2';
      }
      else if (this.lang.toLowerCase() == "en") {
        this.selectedLanguage = { lang: "EN", flag: "us" };
      }
    } 
    else { // Fallback to Dutch 
      this.selectedLanguage = { lang: "NL", flag: "nl" };
    }

    
    this.wolfload = true;
    

    // console.table(
    //   "this.companyId",
    //   this.companyId,
    //   "this.activeBranch",
    //   this.activeBranch,
    //   "this.salonhubname",
    //   this.salonhubname,
    //   "this.lang",
    //   this.lang,
    //   "this.stepperHeight",
    //   this.stepperHeight,
    //   "this.stepperCardHeight",
    //   this.stepperCardHeight,
    //   "this.gender",
    //   this.gender,
    //   "this.clientIntel",
    //   this.clientIntel,
    //   "this.treatmentByParam",
    //   this.treatmentByParam,
    //   "this.clientName",
    //   this.clientName,
    //   "this.clientEmail",
    //   this.clientEmail,
    //   "this.clientTel",
    //   this.clientTel,
    //   "this.showPrice",
    //   this.showPrice,
    //   "this.src",
    //   this.src,
    //   "this.url",
    //   this.url,
    //   "this.clientExist",
    //   this.clientExist,
    //   "this.userAgent",
    //   this.userAgent
    // );

    this.source = this.src;

    //Check local Storage
    if (this.localStorageActive == true) {
      if (typeof window.localStorage.getItem("clientName") !== "undefined")
      this.name = window.localStorage.getItem("clientName");

    if (typeof window.localStorage.getItem("clientEmail") !== "undefined")
      this.email = window.localStorage.getItem("clientEmail");

    if (typeof window.localStorage.getItem("clientPhone") !== "undefined")
      this.tel = window.localStorage.getItem("clientPhone");

    if (typeof window.localStorage.getItem("policyAgree") !== "undefined") {
      this.agreebox = window.localStorage.getItem("policyAgree");
      this.agreeStorage = true;
    }



    }

    

    if (this.clientName) {
      this.name = JSON.parse(JSON.stringify(this.clientName));
    }

    if (this.clientEmail) {
      this.email = JSON.parse(JSON.stringify(this.clientEmail));
    }

    if (this.clientTel) {
      this.tel = JSON.parse(JSON.stringify(this.clientTel));
    }

    //Create doc for calling back
    if (this.clientTel && this.treatmentByParam
    ) {
      this.createClientDoc("byTreatmentTel");
    } 
    else if (this.clientEmail && this.treatmentByParam
    ) {
      this.createClientDoc("byTreatmentEmail");
    } 
    else if (this.clientTel) {
      this.createClientDoc("byTel");
    } 
    else if (this.clientEmail) {
      this.createClientDoc("byEmail");
    }

    if (this.treatmentByParam ) {
      let arrStepOrder = [
        "treatment",
        "employee",
        "date",
        "time",
        "clientInfo",
        "summary"
      ];
      this.stepOrder = [];
      for (let index = 0; index < arrStepOrder.length; index++) {
        this.stepOrder.push({ id: index + 1, name: arrStepOrder[index] });
      }

      this.step = this.stepOrder[0].name;
    }

    //Front Parameter
    if (this.clientIntel == "front") {
      if (this.clientOrder) {
        console.log("Employee First!");
        let arrStepOrder = [
          "clientInfo",
          "employee",
          "treatment",
          "date",
          "time",
          "summary"
        ];
        this.stepOrder = [];
        for (let index = 0; index < arrStepOrder.length; index++) {
          this.stepOrder.push({ id: index + 1, name: arrStepOrder[index] });
        }
      } else {
        let arrStepOrder = [
          "clientInfo",
          "treatment",
          "employee",
          "date",
          "time",
          "summary"
        ];
        this.stepOrder = [];
        for (let index = 0; index < arrStepOrder.length; index++) {
          this.stepOrder.push({ id: index + 1, name: arrStepOrder[index] });
        }
      }

      this.step = this.stepOrder[0].name;
    } else {
      let arrStepOrder = [
        "treatment",
        "employee",
        "date",
        "time",
        "clientInfo",
        "summary"
      ];
      this.stepOrder = [];
      for (let index = 0; index < arrStepOrder.length; index++) {
        this.stepOrder.push({ id: index + 1, name: arrStepOrder[index] });
      }

      this.step = this.stepOrder[0].name;
    }

    //Treatment by Parameter
    if (this.treatmentByParam) {
      let arrStepOrder = [
        "clientInfo",
        "treatment",
        "employee",
        "date",
        "time",
        "summary"
      ];
      this.stepOrder = [];
      for (let index = 0; index < arrStepOrder.length; index++) {
        this.stepOrder.push({ id: index + 1, name: arrStepOrder[index] });
      }

      this.step = this.stepOrder[0].name;
    }

    if (this.gender) {
      this.selectedGender = this.gender;
    }
    this.policyLang = this.policy[this.selectedLanguage.lang.toLowerCase()];
    this.getBasicSalonhub();
  },

  methods: {
    async getBasicSalonhub() {
      
      let salonhubinfo = new Promise((resolve, reject) => {
        axios
          .get(
            `https://public.salonhub.nl/v2/api/OnlineAppointment.Remote.Salons/get?client=${this.salonhubname}&salon=${this.activeBranch}`,
            this.configAxios
          )
          .then(response => {
            console.log("salonhubInfo:", response.data);
            this.salonhubInfo = response.data;

            //DEBUG Settings
            // this.salonhubInfo.settings.emergency.enabled = false;
            // this.salonhubInfo.settings.emergency.blocked = false;

            //Name is too long
            if (
              this.salonhubInfo.salon.name.length > 34 &&
              this.userAgent == "mobile"
              
            ) {
              this.salonhubInfo.salon.name =
                this.salonhubInfo.salon.name.substr(0, 25) + "...";
            }

            resolve();
          })
          .catch(error => {
            console.error("Salonhub Error Widget Info =>", error);
          });
      });

      let salonhubEmployeeOrTreatment = new Promise((resolve, reject) => {
        if(this.treatmentByParam){
          console.log("We have a param for treatment")
          this.treatments = [];
          this.selectedTreatment.id = this.treatmentByParam;
          this.selectedTreatment.name = this.treatmentByParamName ? this.treatmentByParamName : null;
          this.selectedTreatment.price = this.treatmentByParamPrice ? this.treatmentByParamPrice : null;

          axios
          .get(
            `https://public.salonhub.nl/v2/api/OnlineAppointment.Remote.Employees/getForTreatment?client=${this.salonhubname}&salon=${this.activeBranch}&treatment=${this.treatmentByParam}`,
            this.configAxios
          )

          .then(response => {
            console.log("TETATMENT EAMPLOYEE", response.data);
            this.employees = [];
            let employees = response.data.employees;

            employees[0].name = this.$t("nopreference");
            employees[0].photo = "";
            this.employees = employees;
            resolve();
          })
          .catch(error => {
            console.error("Salonhub Error Employees =>", error);
          });

        }
        else{
          if (this.clientOrder) {
            axios
              .get(
                `https://public.salonhub.nl/v2/api/OnlineAppointment.Remote.Employees/get?client=${this.salonhubname}&salon=${this.activeBranch}`,
                this.configAxios
              )

              .then(response => {
                // console.log(response.data);
                this.employees = [];
                let employees = response.data.employees;

                employees[0].name = this.$t("nopreference");
                employees[0].photo = "";
                this.employees = employees;
                resolve();
              })
              .catch(error => {
                console.error("Salonhub Error Employees =>", error);
              });
          }
          else {
            axios

              .get(
                `https://public.salonhub.nl/v2/api/OnlineAppointment.Remote.Treatments/get?client=${this.salonhubname}&salon=${this.activeBranch}`,
                this.configAxios
              )

              .then(response => {
                console.log("treatments:", response.data);
                this.treatments = [];
                this.treatments = response.data;
                
                // let joe = response.data;
                // this.treatments = joe;

                if(this.multipleTreatmentsByParam && this.multipleTreatmentsByParam.length > 0){
                  this.filterTreatments(response.data)
                }

                resolve();
              })
              .catch(error => {
                console.error("Salonhub Error Treatments =>", error);
              });
          }
        }
      });

      Promise.all([salonhubinfo, salonhubEmployeeOrTreatment]).then(() => {
        //Match Index Of ID Treatment

        console.log("Salonhub klaar met laden");
        // this.$emit("BookingEditChange", true);
        this.widgetloaded = true;
        this.employeeFirst = true;
        this.wolfload = false;

        if (this.treatmentByParam) {
          for (let index = 0; index < this.treatments.length; index++) {
            if (this.treatments[index].id == this.treatmentByParam) {
              console.log("Triggert Treatment Param", this.treatmentByParam);
              this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Triggert Treatment Param ${this.treatmentByParam}`})
              this.selectedTreatmentIndex = index;
              break;
            }
          }

          //Without Emergency Scroll Directly to Treatment
          if (this.salonhubInfo.settings.emergency.enabled == false) {
            setTimeout(() => {
              document
                .querySelector(
                  `div > div.v-list-item__title.go${this.treatmentByParam}`
                )
                .scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center"
                });
            }, 1200);
          }
        }
      });
    },

    async filterTreatments(treatments){
      console.log("filterTreatments function")
      let filteredTreatments = new Array();
      let counter = 0;
      this.treatments.treatments.filtered = new Array();
      this.salonhubInfo.settings.treatmentGroups.push({id: 'filtered', name: 'Special'})

      await new Promise((res)=>{
        for (const [key, value] of Object.entries(treatments.treatments)) {
          let catCounter = 0;
          if(value.length > 0){
            value.forEach((treatment)=>{
              if(this.multipleTreatmentsByParam.includes(String(treatment.id))){
                filteredTreatments.push(treatment);
              }
              catCounter++
              if(catCounter == value.length){
                counter++
                if(counter == Object.keys(treatments.treatments).length){
                  res()
                }
              }
            })
          }
          else{
            counter++
            if(counter == Object.keys(treatments.treatments).length){
              res()
            }
          } 
        }      
      })
      console.log("treatments done")
      this.selectedGender = 'filtered';
      this.treatments.treatments.filtered= filteredTreatments
      
      
    },

    //Activated by Treatment Auto Select shtm
    scrollIntoTreatment() {
      setTimeout(() => {
        document
          .querySelector(
            `div > div.v-list-item__title.go${this.treatmentByParam}`
          )
          .scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center"
          });
      }, 1200);
    },

    setSelectedEmployeeData(){
      this.employees.forEach(employee=>{
        if(employee.id == this.skipEmployeeSelectById){
          this.stepIndex = 3;
          this.selectEmployee(employee.id, employee.name);
          this.step = this.stepOrder[3].name;
          
        }
      })
    },


    setSelectedTreatmentData(){
      this.createClientDoc('byFront');
      this.stepIndex = 3;
      this.selectedTreatment.id = this.skipTreatmentSelectById;
      this.selectedTreatment.name = "";
      this.selectedTreatment.price = 0;
      

      for (const [key, value] of Object.entries(this.treatments.treatments)) {
        value.forEach((treatment)=>{
          if(treatment.id == this.skipTreatmentSelectById){
            this.selectedTreatment.name = treatment.name
            this.selectedTreatment.price = treatment.price.value
            if(treatment.price && treatment.price.value){
              let storedPrice = treatment.price.value.toString();
              let convertDotPrice = storedPrice.slice(0, storedPrice.length - 2) + "." + storedPrice.slice(storedPrice.length - 2, storedPrice.length);
              this.selectedTreatment.price = Number(convertDotPrice);
            }
            else{
              this.selectedTreatment.price = 0;
            }
          }
        })
      }

      setTimeout(()=>{
        this.selectEmployee(0, 'Geen voorkeur');
        this.step = this.stepOrder[3].name;
      }, 1000)
     

    },
     

    getIP() {
      // Get IP info
      axios
        .get(
          `https://pro.ip-api.com/json/?key=M08tSvdEklYEPub&fields=status,message,continentCode,country,countryCode,region,regionName,city,zip,lat,lon,timezone,isp,org,as,mobile,proxy,hosting,query`
        )
        .then(response => {
          // console.log(response.data);
          clientData.ip = response.data;
          return true;
        })
        .catch(error => {
          // console.error("Salonhub Error Widget Info =>", error);
          clientData.ip = "";
          return false;
        });
    },

    checkClientExist() {
      // console.log(salonhubApiSettings);

      if (this.email !== "") {
        let clients = null;
        console.log("Check email...");
        this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Check mail`})
        axios
          .get(
            `https://salonhubwidget.hogans.nl/ex?doc=${this.docId}&comp=${this.companyId}&b=${this.activeBranch}&email=${this.email}`
          )
          .then(response => {
            console.log("checkClientExist", response.data);
            clients = response.data;

            // return true;
          })
          .catch(error => {
            console.error("Salonhub Error Widget Info =>", error);
          });
      }
    },

    createClientDoc(form) {


      console.log("Created by: ", form);
      this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Created by ${form}`})



      /* Options of Params
          1. By Front
          2. byTreatmentTel
          3. byTreatmentEmail
          4. By Telephone
          5. By Email
          */

      this.storeData = true;

      let clientData = {
        userAgent: navigator.userAgent,
        device: this.userAgent,
        email: this.email,
        name: this.name,
        phone: this.telTemp
      };

      //Push to GTM

      window.dataLayer?.push({
        event: 'user_start_session',
        category: 'widgetEvents',
        label: 'Widget Sessions with name',
        companyId: this.companyId,
        
      });

      

      //Set Client info to local storage
      if(this.localStorageActive){
        console.log("Local storage active: Set");
        this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Local storage active: Set`});
        window.localStorage.setItem("clientName", this.name);
        window.localStorage.setItem("clientEmail", this.email);
        window.localStorage.setItem("clientPhone", this.tel);
        window.localStorage.setItem("policyAgree", this.agreebox);
      }
      else{
        console.log("Local storage not active: SKIP");
        this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Local storage not active: SKIP`})
      }
      

      let progress = {
        availableForAction: true,
        completed: false,
        completedBy: "user",
        completedOn: null
      };

      clientData.ip = null;

      // this.postNewDoc(clientData, progress, form);

      // Get IP info
      axios
        .get(
          `https://pro.ip-api.com/json/?key=M08tSvdEklYEPub&fields=status,message,continentCode,country,countryCode,region,regionName,city,zip,lat,lon,timezone,isp,org,as,mobile,proxy,hosting,query`
        )
        .then(response => {
          // console.log(response.data);
          this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `IP Api succes`})
          clientData.ip = response.data;
          this.postNewDoc(clientData, progress, form);
        })
        .catch(error => {
          // console.error("Salonhub Error Widget Info =>", error);
          this.debugLog.push({type: 'error', time: moment().format("HH:mm"), log: `IP Api error ${error}`})
          clientData.ip = "";
          this.postNewDoc(clientData, progress, form);
          
        });

    },

    stepBack() {
      new Promise((resolve, reject)=>{
        if(this.stepIndex == 4 && this.skipEmployeeSelectById){
          this.stepIndex = 2;
          resolve();
        }
        else if((this.stepIndex == 2 || this.stepIndex == 3) && this.treatmentByParam){
          this.stepIndex = 1;
          this.selectedEmployeeIndex = 0;
          resolve()
        }
        else if(this.stepIndex == 4 && this.skipTreatmentSelectById){
          this.stepIndex = 1;
          resolve()
        }
        else{
          this.stepIndex--;
          resolve();
        }  
      })
      .then(()=>{
        for (let index = 0; index < this.stepOrder.length; index++) {
          if (this.stepOrder[index].id == this.stepIndex) {
            this.step = this.stepOrder[index].name;

            break;
          }
        }
      })
         
      
    },

    postNewDoc(clientData, progress, form) {
      // console.log(clientData);

      this.actionBy = form;

      db.collection("conversion")
        .add({
          salonhubData: {
            branch: this.activeBranch,
            branchName: this.salonname,
            actionBy: form
            // existingClient: this.clientExist via backend
          },
          source: this.source,
          startUrl: this.startUrl,
          executedFrom: this.executedFrom,
          language: this.selectedLanguage.lang,
          companyId: this.companyId,

          clientData: clientData,
          progress: progress,
          timestamp: new Date(),

          type: "salonhub"
        })
        .then(docRef => {
          console.log("Client Succesfully Created =>", docRef.id);
          this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Client Succesfully Created => ${docRef.id}`})
          this.docId = docRef.id;
          this.tel = this.telTemp;

          if (this.email !== "") {
            let clients = null;

            // console.log("Check email");
            axios

              .get(
                `https://salonhubwidget.hogans.nl/ex?doc=${this.docId}&comp=${this.companyId}&b=${this.activeBranch}&email=${this.email}`
              )
              .then(response => {
                console.log("Sven", response.data);
                clients = response.data;

                return true;
              })
              .catch(error => {
                this.$errorHandler.report("Error Checking Email Client Exist =>", error);
                // console.error("Error Checking Email Client Exist =>", error);
              });
          }
        })
        .catch(error => {
          console.error("Error writing document: ", error);
        });
    },

    callMe(){
      db.collection("conversion")
        .doc(this.docId)
        .set(
          {
            progress: {
              callMe: true,
            },
            timestampUpdated: new Date()
          },
          { merge: true }
        )
        .then(() => {
          this.showCallbackButtonClicked = true;
        })
    },

    closeDialog() {
      this.wolfload = false;
      //Reset alle waardes.

      if (this.confirmed == true) {
        //Succesfull
        if (this.userAgent == "mobile") {
          if (this.succesUrl.length !== 0)
            window.location.href = this.succesUrl;
          Object.assign(this.$data, this.$options.data());
          console.log("Closed Conversion ID, MOBILE");
          this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Closed Conversion ID, MOBILE`});
        } else {
          let widgetObject = { message: "widgetKill", url: this.succesUrl };
          parent.postMessage(widgetObject, "*");
          this.$emit("BookingEditChange", false);
          Object.assign(this.$data, this.$options.data());
          console.log("Closed Conversion ID, DESKTOP");
          this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Closed Conversion ID, DESKTOP`})
        }
      } 
      else {
        //Not succesful with DocID

        if (this.docId !== null) {
          // Does company want to ask for feedback?
          if (this.feedBackOnClose) {
            this.closedWithFeedback = true;
          }
          //Company doesnt use callcenter
          else {
            db.collection("conversion")
              .doc(this.docId)
              .set({
                  salonhubData: {
                    dialogClosed: true
                  },
                  timestampUpdated: new Date()
                },
                { merge: true }
              )
              .then(() => {
                // console.log(this.docId, "Dialog Closed");

                if (this.userAgent == "mobile") {
                  // console.log("Closed with ID, without callcenter, MOBILE");

                  window.location.href = this.url;
                  Object.assign(this.$data, this.$options.data());
                } else {
                  let widgetObject = { message: "widgetKill", url: null };
                  parent.postMessage(widgetObject, "*"); // :) Kill that dialog via Iframe
                  Object.assign(this.$data, this.$options.data());

                  this.$emit("BookingEditChange", false);
                  // console.log("Closed with ID, without callcenter, DESKTOP");
                }
              })
              .catch(error => {
                console.error("Error Dialog Closed => : ", error);
              });
          }
        } else {
          //Not succesful without DocID
          if (this.userAgent == "mobile") {
            window.location.href = this.url;
            Object.assign(this.$data, this.$options.data());

            console.log("Closed without ID, MOBILE");
            this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Closed without ID, Mobile`})
          } else {
            let widgetObject = { message: "widgetKill", url: null };
            parent.postMessage(widgetObject, "*");
            // parent.postMessage("widgetKill", "*", "test"); // :) Kill that dialog via Iframe
            Object.assign(this.$data, this.$options.data());
            this.$emit("BookingEditChange", false);
            console.log("Closed without ID, DESKTOP");
            this.debugLog.push({type: 'info',  time: moment().format("HH:mm"),log: `Closed without ID, DESKTOP`})
          }
        }
      }
    },

    fullyClosed() {

      let clientCloseReason = null;
      new Promise((resolve)=>{
        if(this.exitReason){
          if(this.exitReason == 'noSpaceFound'){
            clientCloseReason = 'noSpaceFound';
            if(this.smsSettings.smsOnClose){
              // SMS API CALL WITH DOC ID
             
              axios.post('https://salonhubwidget.hogans.nl/sendsms', {
                email: this.email,
                phone: this.tel,
                smsSettings: this.smsSettings,
                language: String(this.selectedLanguage.lang).toLowerCase(),
                doc: this.docId
              })
              .then((response) => {
                console.log(response);
              }, (error) => {
                console.error("Error sending sms", error);
              });
              resolve()
            }
            else{
              resolve();
            }
            
          }
          else if(this.exitReason == 'restartingWidget'){
            clientCloseReason = 'restartingWidget';
            resolve();
          }
          else if(this.exitReason == 'other'){
            clientCloseReason = this.customExitReason;
            resolve();
          }
        }
        else{
          if(this.smsSettings.smsOnClose){
            // SMS API CALL WITH DOC ID
              axios.post('https://salonhubwidget.hogans.nl/sendsms', {
                email: this.email,
                phone: this.tel,
                smsSettings: this.smsSettings,
                language: String(this.selectedLanguage.lang).toLowerCase(),
                doc: this.docId
              })
            .then((response) => {
              console.log(response);
            }, (error) => {
              console.error("Error sending sms", error);
            });
            resolve();
          }
          else{
            resolve();
          }
        }
      })
      .then(()=>{
        if (this.docId !== null) {
          db.collection("conversion")
            .doc(this.docId)
            .set(
              {
                salonhubData: {
                  dialogClosed: true,
                  closeReason: clientCloseReason 
                },
                timestampUpdated: new Date()
              },
              { merge: true }
            )
            .then(() => {
              console.log(this.docId, "Dialog Closed");
               this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Dialog Closed`})

              if (this.userAgent == "mobile") {
                Object.assign(this.$data, this.$options.data());
                console.log("Closed with ID, MOBILE");
                 this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Closed with ID, MOBILE`})

                window.location.href = this.url;
              } else {
                let widgetObject = { message: "widgetKill", url: null };
                parent.postMessage(widgetObject, "*");
                Object.assign(this.$data, this.$options.data());

                this.$emit("BookingEditChange", false);
                console.log("Closed with ID, DESKTOP");
                this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Closed with ID, DESKTOP`})
              }
            })
            .catch(error => {
              console.error("Error Dialog Closed => : ", error);
            });
        } else {
          if (this.userAgent == "mobile") {
            Object.assign(this.$data, this.$options.data());
            console.log("Closed with ID, MOBILE");
            this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Closed with ID, MOBILE`})

            window.location.href = this.url;
          } else {
            let widgetObject = { message: "widgetKill", url: null };
            parent.postMessage(widgetObject, "*"); // :) Kill that dialog via Iframe
            Object.assign(this.$data, this.$options.data());
            this.$emit("BookingEditChange", false);
            console.log("Closed without ID, DESKTOP");
            this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Closed without ID, DESKTOP`})
          }
        }
      })
    },

    //2.
    selectTreatment(index, treatment) {
      console.log("selectTreatment: ", index)
      this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `selectTreatment ${index}`})
      //treatment.id, treatment.name, treatment.price.value
      this.selectedTreatment.id = treatment.id;
      this.selectedTreatment.name = treatment.name;
      
      this.selectedTreatment.price = null;
      let storedPrice = 0;
      if(treatment.price && treatment.price.value){
        storedPrice = treatment.price.value.toString();
        let convertDotPrice = storedPrice.slice(0, storedPrice.length - 2) + "." + storedPrice.slice(storedPrice.length - 2, storedPrice.length);
        this.selectedTreatment.price = Number(convertDotPrice);
      }
       
      this.wolfload = true;

      if (this.clientOrder) {
        console.log(
          "Employee First: Employee Selected, Treatment Selectect => Loading Dates..."
        );
        this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Employee Selected, Treatment Selectect => Loading Dates...`})

        let previous = null;
        let firstDates = false;
        let modifiedDate = [];
        this.datesLoading = true;

        (async () => {
          // console.log("Start gathering Dates");
          let dates = new Array();
          let startLimit = 0;
          let endLimit = 14;
          for (let index = 0; index < 10; index++) {
            console.log(index);
            await axios

              .get(
                `https://public.salonhub.nl/v2/api/OnlineAppointment.Remote.Dates/get?client=${this.salonhubname}&salon=${this.activeBranch}&treatment=${this.selectedTreatment.id}&employee=${this.tempEpmloyeeID}&limit=${endLimit}&start=${startLimit}`,
                this.configAxios
              )

              .then(response => {   
                console.log("axios is klaar", response.data);

                this.dateMin = response.data.minimum;
                this.dateMax = response.data.maximum;
                dates.push(...response.data.dates);

                startLimit += 14;

                // console.log("Date done!");
                return;
              })
              .catch(error => {
                this.wolfload = false;
                if (this.callTo !== null) {
                  this.salonhubError = true;
                }

                console.error("Salonhub Error Dates =>", error);
              });
              
              console.log("Doorgaan!")

              if(dates.length > 0){
                console.log("Dates is groter dan 0")
                this.renderAvailableDates(index, dates)
                if(!firstDates){
                  
                  firstDates = true;

                  if (this.storeData == true) {
                    db.collection("conversion")
                      .doc(this.docId)
                      .set(
                        {
                          salonhubData: {
                            steps: {
                              employee: {
                                id: this.selectedEmployee.id,
                                name: this.selectedEmployee.name
                              },
                              treatment: {
                                price: this.selectedTreatment.price,
                              }
                            }
                          },
                          timestampUpdated: new Date(),
                          value: {
                            number: this.selectedTreatment.price,
                            type: "amount"
                          }
                        },
                        { merge: true }
                      )
                      .then(() => {
                        console.log(this.docId, "Employee succesfully updated");
                      })
                      .catch(error => {
                        console.error("Error Update Employee Data => : ", error);
                      });
                  }

                  this.step = "date";
                  this.stepIndex++;
                  this.wolfload = false;
                  setTimeout(() => {
                    document
                      .querySelector(".toplistdate")
                      .scrollIntoView({ inline: "nearest" });
                  }, 200);
                }
                else{
                  console.log("no firstDates")
                }
                
              }
              else{
                console.log("dat is niet groter dan null")
              }
          }

          console.log("End", dates);
          this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `end ${dates}`})
          

  
        })();
      } 
      else {
        let employeePromise = new Promise((resolve, reject) => {
          axios

            .get(
              `https://public.salonhub.nl/latest/api/OnlineAppointment.Remote.Employees/getForTreatment?client=${this.salonhubname}&salon=${this.activeBranch}&treatment=${treatment.id}`,
              this.configAxios
            )

            .then(response => {
              // console.log(response.data);
              this.employees = [];
              let employees = response.data.employees;

              //No Preference Legacy
              // employees.unshift({
              //   id: "0",
              //   name: this.$t("nopreference"),
              //   photo: ""
              // });

              employees[0].name = this.$t("nopreference");
              employees[0].photo = "";
              this.employees = employees;

              if(this.skipEmployeeSelectById){
                this.setSelectedEmployeeData()
              }
              else{
                this.step = "employee";
                this.stepIndex++;
                this.wolfload = false;
              }
              
              resolve();
            })
            .catch(error => {
              this.wolfload = false;
              if (this.callTo !== null) {
                this.salonhubError = true;
              }

              console.error("Error Salonhub Employees =>", error);
            });
        });

  

        Promise.all([employeePromise]).then(() => {
          // setTimeout(() => {
          //   document.querySelector(".employee0").scrollIntoView({
          //     behavior: "smooth",
          //     block: "center",
          //     inline: "center"
          //   });
          // }, 1000);
        });

        if (this.storeData == true) {
          db.collection("conversion")
            .doc(this.docId)
            .set(
              {
                salonhubData: {
                  steps: {
                    treatment: {
                      id: this.selectedTreatment.id,
                      name: this.selectedTreatment.name,
                      price: this.selectedTreatment.price
                    },
                    gender: {
                      id: this.selectedGender,
                      name: this.selectedGenderHuman
                    }
                  }
                },
                timestampUpdated: new Date(),
                value: {
                  number: this.selectedTreatment.price,
                  type: "amount"
                }
              },
              { merge: true }
            )
            .then(() => {
              console.log(this.docId, "Treatment succesfully updated");
              this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `${this.docId} Treatment succesfully updated`})
            })
            .catch(error => {
              console.error("Error Update Treatment Data => : ", error);
              this.debugLog.push({type: 'error', time: moment().format("HH:mm"), log: `Error Update Treatment Data => ${error}`})
            });
        }
      }
    },
    //3
    selectEmployee(id, name) {
      this.selectedEmployee.id = id;
      this.selectedEmployee.name = name;

      if (this.selectedEmployee.id == 0) {
        this.tempEpmloyeeID = "0";
      } else {
        this.tempEpmloyeeID = this.selectedEmployee.id;
      }

      this.wolfload = true;

      if (this.clientOrder) {
        console.log("Employee First: Loading Employee for Treatment");
        this.debugLog.push({type: 'info',  time: moment().format("HH:mm"), log: `Employee First: Loading Employee for Treatment`})

        axios
          .get(
            `https://public.salonhub.nl/v2/api/OnlineAppointment.Remote.Treatments/getForEmployee?client=${this.salonhubname}&salon=${this.activeBranch}&employee=${this.tempEpmloyeeID}`,
            this.configAxios
          )

          .then(response => {
            // console.log(response.data);
            this.treatments = response.data;

            if (this.storeData == true) {
              db.collection("conversion")
                .doc(this.docId)
                .set(
                  {
                    salonhubData: {
                      steps: {
                        employee: {
                          id: this.selectedEmployee.id,
                          name: this.selectedEmployee.name
                        },
                        treatment: {
                          id: this.selectedTreatment.id,
                          name: this.selectedTreatment.name,
                        }
                      }
                    },
                    timestampUpdated: new Date()
                  },
                  { merge: true }
                )
                .then(() => {
                  console.log(this.docId, "Employee succesfully updated");
                  this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Employee succesfully updated`})
                  this.step = "treatment";
                  this.stepIndex++;
                  this.wolfload = false;
                })
                .catch(error => {
                  console.error("Error Update Employee Data => : ", error);
                });
            }
          })
          .catch(error => {
            this.wolfload = false;
            if (this.callTo !== null) {
              this.salonhubError = true;
            }
            console.error("Salonhub Error Treatments =>", error);
          });
      }
      else {
        setTimeout(() => {
          document
            .querySelector(".toplistdate")
            .scrollIntoView({ inline: "nearest" });
        }, 1200);

        console.log(
          "Get Date: Treatment.id",
          this.selectedTreatment.id,
          "employee id",
          this.tempEpmloyeeID
        );

        this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Get Date: Treatment.id  ${this.selectedTreatment.id} employee id  ${this.tempEpmloyeeID}`})

        let previous = null;
        let modifiedDate = [];

        (async () => {
          // console.log("Start gathering Dates");
          let dates = new Array();
          let startLimit = 0;
          let endLimit = 14;
          let firstDates = false;
          this.datesLoading = true;

          for (let index = 0; index < 10; index++) {
            console.log(index);
            console.log("Start limit: ", startLimit)
            console.log("End limit: ", endLimit)
            await axios.get(
                `https://public.salonhub.nl/v2/api/OnlineAppointment.Remote.Dates/get?client=${this.salonhubname}&salon=${this.activeBranch}&treatment=${this.selectedTreatment.id}&employee=${this.tempEpmloyeeID}&limit=${endLimit}&start=${startLimit}`,
                this.configAxios
              )

              .then(response => {
                console.log("response: ",response.data);

                this.dateMin = response.data.minimum;
                this.dateMax = response.data.maximum;
                dates.push(...response.data.dates);

                startLimit += 14;
                // console.log("Date done!");
                return;
              })
              .catch(error => {
                this.wolfload = false;
                if (this.callTo !== null) {
                  this.salonhubError = true;
                }
                console.error("Salonhub Error Dates =>", error);
              });

              if(dates.length > 0){
                this.renderAvailableDates(index, dates)
                if(!firstDates){
                  
                  firstDates = true;
                  if (this.storeData == true) {
                    db.collection("conversion")
                      .doc(this.docId)
                      .set(
                        {
                          salonhubData: {
                            steps: {
                              employee: {
                                id: this.selectedEmployee.id,
                                name: this.selectedEmployee.name
                              },
                              treatment: {
                                id: this.selectedTreatment.id,
                                name: this.selectedTreatment.name,
                              },
                            }
                          },
                          timestampUpdated: new Date(),
                          value: {
                            number: this.selectedTreatment.price,
                            type: "amount"
                          }
                        },
                        { merge: true }
                      )
                      .then(() => {
                        console.log(this.docId, "Employee succesfully updated");
                      })
                      .catch(error => {
                        console.error("Error Update Employee Data => : ", error);
                        this.debugLog.push({type: 'error', time: moment().format("HH:mm"), log: `Error Update Employee Data  ${error}`})
                      });
                  }

                  this.step = "date";
                  this.stepIndex++;
                  this.wolfload = false;
                  setTimeout(() => {
                    document
                      .querySelector(".toplistdate")
                      .scrollIntoView({ inline: "nearest" });
                  }, 200);
                }
              }

              if(index == 5 && dates.length == 0){
                this.step = "date";
                this.stepIndex++;
                this.wolfload = false;
                this.datesLoading = false;
                this.modifiedDate = [];
                console.log("End with no dates");  
                this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `End with no dates}`})
              }
              //  dates = new Array();
          }

          

          console.log("End", dates);
          this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `End ${dates}`})
        })();
      }
    },

    renderAvailableDates(index, dates){
      console.log("dates: ", dates)
      let previous = null;
      let modifiedDate = [];

      for (let i = 0; i < dates.length; i++) {
        
        // console.log("Weeks", weeks, dates[i].date);

        // console.log("Salonhub: ", dates[i].date,  moment(dates[i].date, "YYYY-MM-DD"))
          let d = moment(dates[i].date, "YYYY-MM-DD");
          let reformatDate = moment(dates[i].date, "YYYY-MM-DD")
            .locale("NL")
            .format("dddd D MMMM YYYY");
          let weeks = moment(d)
            .startOf("day")
            .isoWeekday(1)
            .diff(
              moment()
                .startOf("day")
                .isoWeekday(1),
              "weeks"
            );

          if (weeks != previous) {
            let title = `${this.$t(
              "desc.vocabulary.after"
            )} ${weeks} ${this.$t("desc.dates.weeks")}`;

            if (weeks == 0) {
              title = `${this.$t("desc.vocabulary.this")} ${this.$t(
                "desc.dates.week"
              )}`; //This week
            }

            if (weeks == 1) {
              title = `${this.$t("desc.vocabulary.next")} ${this.$t(
                "desc.dates.week"
              )}`; //Next week
            }

            modifiedDate.push({ type: "group", name: title, id: "" });

            previous = weeks;
          }
          modifiedDate.push({
            type: "datestamp",
            name: reformatDate,
            // id: moment(dates[i], "DD-MM-YYYY").format("YYYY-MM-DD") //Legacy
            id: moment(dates[i].date)
          });
        }
        if(index == 5){
          this.datesLoading = false;
        }

     this.modifiedDate = modifiedDate;

          
    },


    //4
    selectDate(chosenDate, name) {
      this.selectedDate.id = chosenDate;
      this.selectedDate.name = name;
      this.wolfload = true;
      let sven = moment(this.selectedDate.id).format("YYYY-MM-DD");

      axios
        .get(
          `https://public.salonhub.nl/latest/api/OnlineAppointment.Remote.Times/get?client=${
            this.salonhubname
          }&salon=${this.activeBranch}&treatment=${
            this.selectedTreatment.id
          }&employee=${this.tempEpmloyeeID}&date=${moment(
            this.selectedDate.id
          ).format("YYYY-MM-DD")}`,
          this.configAxios
        )
        .then(response => {
          console.log(response.data);
          this.times = [];
          let tempTime = response.data.times;

          for (let index = 0; index < tempTime.length; index++) {
            this.times.push(tempTime[index].time.substr(0, 5));
          }

          if (this.storeData == true) {
            db.collection("conversion")
              .doc(this.docId)
              .set(
                {
                  salonhubData: {
                    steps: {
                      date: moment(this.selectedDate.id).format("YYYY-MM-DD"),
                      datestamp: moment("2020-10-24").unix()
                    }
                  },
                  timestampUpdated: new Date()
                },
                { merge: true }
              )
              .then(() => {
                console.log(this.docId, "Date succesfully updated");
              })
              .catch(error => {
                console.error("Error Update Date Data => : ", error);
              });
          }

          this.step = "time";
          this.stepIndex++;
          this.wolfload = false;
          setTimeout(() => {
            document
              .querySelector(".toplisttime")
              .scrollIntoView({ inline: "nearest" });
          }, 200);
        })
        .catch(error => {
          console.error("Error Axios =>", error);
        });
    },
    //5
    selectTime(time) {
      this.wolfload = true;

      this.selectedTime = time;

      if (this.clientIntel == "front") {
        this.step = "summary";

        for (let index = 0; index < this.stepOrder.length; index++) {
          if (this.stepOrder[index].name == this.step) {
            this.stepIndex = this.stepOrder[index].id;

            break;
          }
        }
      } 
      else {
        this.step = "clientInfo";
        for (let index = 0; index < this.stepOrder.length; index++) {
          if (this.stepOrder[index].name == this.step) {
            this.stepIndex = this.stepOrder[index].id;

            break;
          }
        }
      }

      if (this.treatmentByParam && this.clientIntel !== "front") {
        this.step = "clientInfo";
        for (let index = 0; index < this.stepOrder.length; index++) {
          if (this.stepOrder[index].name == this.step) {
            this.stepIndex = this.stepOrder[index].id;

            break;
          }
        }
      }

      if (this.storeData == true) {
        db.collection("conversion")
          .doc(this.docId)
          .set(
            {
              salonhubData: {
                steps: {
                  time: this.selectedTime
                }
              },
              timestampUpdated: new Date()
            },
            { merge: true }
          )
          .then(() => {
            console.log(this.docId, "Time succesfully updated");
            this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Time succesfully updated`})
          })
          .catch(error => {
            console.error("Error Update Time Data => : ", error);
            this.debugLog.push({type: 'error', time: moment().format("HH:mm"), log: `Error Update Time Data => :  ${error}`})
          });
      }

      this.wolfload = false;
    },
    clientDataForm(type) {

      console.log("clientDataForm")
      /*
          Option 1: Send all data as last step when Back is activated
          Option 2: Send only client info by Treatment or by Params

          */

      this.wolfload = true;

      //Checker for Hogans Confirm Mail
      let sendMailbySalonhub = true;

      this.confirmMail == true // Bij Actief Salonhub op False
        ? (sendMailbySalonhub = false)
        : (sendMailbySalonhub = true);
      console.log("jsonOBJ: ", jsonOBJ)
      //JSON for posting to Salonhub
      let jsonOBJ = {
        settings: {
          application: "nl.salonhub.widget",
          guid: uuidv4(),
          email: {
            enabled: sendMailbySalonhub,
            urls: {
              cancel: this.url + "#salonhub-cancel-client:{CLIENT}-salon:{SALON}-id:{APPOINTMENT}-confirm:{TOKEN}",
              verify: this.url + "#salonhub-confirm-client:{CLIENT}-salon:{SALON}-id:{APPOINTMENT}-code:{CODE}"
            }
          }
        },
        appointment: {
          date: moment(this.selectedDate.id).format("YYYY-MM-DD"),
          treatments: [
            {
              time: this.selectedTime + ":00",
              employee: this.tempEpmloyeeID,
              treatment: this.selectedTreatment.id
            }
          ]
        },
        customer: {
          name: this.name,
          email: this.email,
          telephone: this.tel
        }
      };

      console.log(jsonOBJ);

      new Promise((resolve, reject) => {
        console.log("checkClientExist")
        if (this.checkClientExist()) {
          console.log("Ja")
          resolve();
          
        } else {
          console.log("Nee")
          resolve();
        }
      }).then(() => {
        let salonhubRes = null;
        console.log("DATA EXAMPLE: ", jsonOBJ)
        axios
          .post(
            `https://public.salonhub.nl/v2/api/OnlineAppointment.Remote.Appointments/create?client=${this.salonhubname}&salon=${this.activeBranch}`,
            jsonOBJ,
            this.configAxiosPOST
          )
          .then(response => {
            // console.log(response.data);
            console.log(response.data);
            let salonhubRes = response.data;

            if (type == "back" && this.docId == null) {
              let convertedPrice = this.selectedTreatment.price.replace(
                ",",
                "."
              );

              new Promise((resolve, reject) => {
                if (this.getIP()) {
                  resolve();
                } else {
                  resolve();
                }
              }).then(() => {
                db.collection("conversion")
                  .add({
                    salonhubData: {
                      salonhubRes: salonhubRes,
                      dialogClosed: true,
                      salonhubComp: this.salonhubname,
                      url: this.url,
                      branch: this.activeBranch,
                      branchName: this.salonname,
                      actionBy: type,
                      // existingClient: this.clientExist,

                      steps: {
                        treatment: {
                          id: this.selectedTreatment.id,
                          name: this.selectedTreatment.name,
                          price: Number(convertedPrice)
                        },
                        gender: {
                          id: this.selectedGender,
                          name: this.selectedGenderHuman
                        },
                        employee: {
                          id: this.selectedEmployee.id,
                          name: this.selectedEmployee.name
                        },
                        date: moment(this.selectedDate.id).format("YYYY-MM-DD"),
                        datestamp: moment(
                          this.selectedDate.id,
                          "DD-MM-YYYY"
                        ).unix(),
                        time: this.selectedTime
                      }
                    },
                    value: {
                      number: Number(convertedPrice),
                      type: "amount"
                    },

                    language: this.selectedLanguage.lang,
                    source: this.source,
                    smsSend: false,
                    executedFrom: this.executedFrom,
                    companyId: this.companyId,
                    timestamp: new Date(),
                    timestampUpdated: new Date(),
                    type: "salonhub",
                    progress: {
                      completed: true,
                      availableForAction: false,
                      completedBy: "user",
                      completedOn: new Date()
                    },
                    clientData: {
                      device: this.userAgent, //Dynamisch maken
                      userAgent: navigator.userAgent,
                      email: this.email,
                      name: this.name,
                      phone: this.tel
                    }
                  })
                  .then(docRef => {
                    this.docId = docRef.id;
                    console.log(
                      this.docId,
                      "Complete profile via Summarysuccesfully updated, time to send mail"
                    );

                    this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Complete profile via Summarysuccesfully updated, time to send mail`})

                    this.wolfload = false;
                    this.confirmed = true;

                    //Send Mail system
                    axios
                      get(`https://salonhubwidget.hogans.nl/book?doc=${this.docId}&comp=${this.companyId}`)
                      // .get(`https://localhost:9993.hogans.nl/book?doc=${this.docId}&comp=${this.companyId}`)
                      .then(response => {
                        // console.log(response.data);
                        console.log("Backend Book", response.data);
                      })
                      .catch(error => {
                        console.error(
                          "Mailing Backend Error Widget Info =>",
                          error
                        );
                        this.debugLog.push({type: 'error', time: moment().format("HH:mm"), log: `Mailing Backend Error Widget Info => ${error}`})
                      });
                  })
                  .catch(error => {
                    console.error(
                      "Error Update Complete Profile via Summary Data => : ",
                      error
                    );
                    this.debugLog.push({type: 'error', time: moment().format("HH:mm"), log: `Error Update Complete Profile via Summary Data => ${error}`})
                  });
              });
            } else {
              //Not Anomymous
              db.collection("conversion")
                .doc(this.docId)
                .set(
                  {
                    companyId: this.companyId,
                    salonhubData: {
                      salonhubRes: salonhubRes,
                      dialogClosed: true,
                      actionBy: this.actionBy,
                      salonhubComp: this.salonhubname,
                      // existingClient: this.clientExist,
                      url: this.url,
                      branch: this.activeBranch,
                      branchName: this.salonname
                    },
                    language: this.selectedLanguage.lang,
                    source: this.source,
                    clientData: {
                      userAgent: navigator.userAgent,
                      device: this.userAgent, //Dynamisch maken
                      email: this.email,
                      name: this.name,
                      phone: this.tel
                    },
                    progress: {
                      completed: true,
                      availableForAction: false,
                      completedBy: "user",
                      completedOn: new Date()
                    },
                    timestampUpdated: new Date()
                  },
                  { merge: true }
                )
                .then(() => {
                  console.log(this.docId, "Booking succesfully updated");

                  //Google Datalayer conversion GTM event
                  window.dataLayer?.push({
                    event: 'conversionBooking',
                    category: 'widgetEvents',
                    label: 'Widget Sessions',
                    transaction_id: this.docId,
                    value: this.selectedTreatment.price,
                    currency: 'EUR',
                    companyId: this.companyId,
                    email: this.email
                 });

                  this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Booking succesfully updated`})
                  // console.log(jsonOBJ);

                  this.wolfload = false;
                  this.confirmed = true;

                  //Send Mail system
                  axios
                    .get(`https://salonhubwidget.hogans.nl/book?doc=${this.docId}&comp=${this.companyId}`)
                    // .get(`http://localhost:9993/book?doc=${this.docId}&comp=${this.companyId}`)
                    .then(response => {
                      // console.log(response.data);
                      console.log("Backend Book", response.data);
                    })
                    .catch(error => {
                      console.log(
                        "Mailing Backend Error Widget Info =>",
                        error
                      );
                      this.debugLog.push({type: 'error', time: moment().format("HH:mm"), log: `Mailing Backend Error Widget Info =>${error}`})
                    });
                })
                .catch(error => {
                  console.log("Error Update Summary Data => : ", error);
                  this.debugLog.push({type: 'error', time: moment().format("HH:mm"), log: `Error Update Summary Dat =>${error}`})
                });
            }
          })
          .catch(error => {
            if (this.callTo !== null) {
              this.salonhubError = true;
            }
            console.error("Contact Salonhub Error Widget =>", error);
          });
      });
    },
    
    testSven(){
      this.formChanges++
    },

    callTheClient() {
      //Axios
      this.callClient = true;

      let jsonOBJ = {
        settings: {
          callto: this.tel,
          forwardfrom: this.callcenter.twilioNumber,
          companynr: this.callTo,
          TWflow: this.callcenter.TWflow
        },
        clientinfo: {
          docID: this.docId
        }
      };

      let timeoutHandle;
      let countdown = (minutes, seconds) => {
        let tick = () => {
          this.callCounter =
            minutes.toString() +
            ":" +
            (seconds < 10 ? "0" : "") +
            String(seconds);
          seconds--;
          if (seconds >= 0) {
            timeoutHandle = setTimeout(tick, 1000);
          } else {
            if (minutes >= 1) {
              // countdown(mins-1);   never reach “00″ issue solved:Contributed by Victor Streithorst
              setTimeout(function() {
                countdown(minutes - 1, 59);
              }, 1000);
            }
          }
        };
        tick();
      };

      countdown(1, 30);

      let configHeaders = {
        headers: {
          "Content-Type": "application/json"
        }
      };

      axios
        .post(`https://callcenter.hogans.nl/call`, jsonOBJ, configHeaders)
        .then(response => {
          console.log(response.data);
          if (response.data.statusResponse.status == 200) {
            setTimeout(() => {
              this.succesfullCall = true;
            }, 3500);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  watch: {
    debugLog(){
      let logs = document.getElementById("debug-logs");
      setTimeout(function(){ 
        logs.scrollTop = logs.scrollHeight;
       }, 100);
    },
    selectedGender() {
      if (this.selectedGender == "male") {
        this.selectedGenderHuman = "Heren";
      }

      if (this.selectedGender == "female") {
        this.selectedGenderHuman = "Dames";
      }

      if (this.selectedGender == "kids") {
        this.selectedGenderHuman = "Kids";
      }
    },
    step() {
      // this.stepIndex = this.stepOrder.indexOf(this.step) + 1;
      // for (let index = 0; index < this.stepOrder.length; index++) {
      //   if (this.stepIndex == this.stepOrder[index].id) {
      //     console.log("Match!")
      //     this.step = this.stepOrder[index].name;
      //     break;
      //   }
      // }
    },

    tel() {
      if (this.tel !== null) {
        if ((this.selectedPhoneLanguage.flag != 'be' && this.tel.length <= 8) || (this.selectedPhoneLanguage.flag == 'be' && this.tel.length <= 7)) {
                //Niet genoeg nummer
                // console.log("Niet genoeg nummers");
                this.valid = false;
                // this.agreebox = false;
              }
      }
      

      // if (this.tel.length > 9) {
      //   this.$refs.form.validate();
      // }

      let newPhone = new Array();

      if (this.selectedPhoneLanguage.phone != "Other") {
        // console.log("Country code selected Active");
        this.debugLog.push({type: 'info', time: moment().format("HH:mm"), log: `Country code selected Active`})
        newPhone = phoneVal(this.tel, this.selectedPhoneLanguage.phone, true);

        if (newPhone.length != 0) {
          // console.log("Goedgekeurd", newPhone);
          // this.step = this.stepOrder[this.stepIndex++].name;
          this.telTemp = newPhone[0];
        } else {
          // console.log("Afgekeurd", newPhone);
          this.valid = false;
        }
      } else {
        // console.log("Other Active");
        newPhone = phoneVal(this.tel, "", true);

        if (newPhone.length != 0) {
          // console.log("Goedgekeurd", newPhone);
          this.telTemp = newPhone[0];
          // this.step = this.stepOrder[this.stepIndex++].name;
        } else {
          // console.log("Afgekeurd", newPhone);
          this.valid = false;
        }
      }
    },
    selectedPhoneLanguage() {
      if (this.selectedPhoneLanguage.phone == "Other") {
        this.tel = "+31";
      }
    },
    selectedLanguage() {
      if(this.lang == 'nl2' && this.selectedLanguage.lang == 'NL'){
        this.$i18n.locale = 'NL2';
      }
      else{
        this.$i18n.locale = this.selectedLanguage.lang;
      }
      this.policyLang = this.policy[this.selectedLanguage.lang.toLowerCase()];
    }
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Kies behandeling";
        case 2:
          return "Kies medewerker";
        default:
          return "Account created";
      }
    }

    // userCompanies() {
    //   return this.$store.state.userCompanies;
    // },
    // userCompany() {
    //   return this.$store.state.userCompany;
    // },
    // userFirstName() {
    //   return this.$store.state.userFirstName;
    // },
    // userLastName() {
    //   return this.$store.state.userLastName;
    // },
    // userRole() {
    //   return this.$store.state.userRole;
    // },
  }
};
</script>

<style scoped>
.headfirst {
  position: relative;
  padding: 12px 14px !important;
  background-color: #f5f5f5;
  height: 54px;
}

.wolfload-time {
  position: absolute;
  left: 50%;
  top: 50%;
}

.wolfload-time .blackbox {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
  height: 60px;
  width: 60px;
  padding: 12px;
  z-index: 950;
  background-color: #fff;
  border-radius: 15px;
  -webkit-box-shadow: 4px 4px 5px 1px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 4px 4px 5px 1px rgba(0, 0, 0, 0.2);
  box-shadow: 4px 4px 5px 1px rgba(0, 0, 0, 0.2);
}

.languageSelect ::before {
  border: none !important;
}
.languageSelect ::after {
  border: none !important;
}

.stickySteps {
  /* position: fixed; */
  background: #fff;
  height: 120px;
  top: 100;
  width: 630px;
  z-index: 900;
  padding: 0 0 5px 0;
}

.stickyTitle {
  /* position: fixed; */
  background: #fff;

  height: 60px;
  top: 60;
  width: 612px;
  z-index: 900;
}

.v-dialog {
  overflow-y: hidden !important;
}

.v-application .mr-4 {
  margin-right: 0px !important;
}

/* Hide scrollbar for Chrome, Safari and Opera */
/* .v-dialog--scrollable > .v-card > .v-card__text::-webkit-scrollbar {
    display: none;
  } */

/* Hide scrollbar for IE and Edge */
.v-dialog--scrollable > .v-card > .v-card__text {
  -ms-overflow-style: none;
}

.v-list--three-line .v-list-item,
.v-list-item--three-line {
  min-height: 40px;
}

.v-stepper__content {
  padding: 8px 12px 12px 12px;
}

.v-stepper__step {
  padding: 10px !important;
}

.v-stepper {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 54px !important;
}

.v-stepper__header {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  height: 48px !important;
}

.v-list-item.v-item--active.v-list-item--active.v-list-item--link.theme--light.treatment {
  color: #1976d2 !important;
  caret-color: #1976d2 !important;
  animation: v-list-item--active 1.2s infinite;
}

span.stepCount {
  margin-top: -28px;
  color: white;
}

.treatment {
  background-color: #f6f6f6;
  border: 1px solid #ddd;
  margin: 1px 0 1px 0;
}

.employeelist {
  background-color: #f6f6f6;
  border: 1px solid #ddd;
  margin: 1px 0 1px 0;
}

.datestamp {
  background-color: #f6f6f6;
  border: 1px solid #ddd;
  margin: 1px 0 1px 0;
}

.time {
  background-color: #f6f6f6;
  border: 1px solid #ddd;
  margin: 1px 0 1px 0;
}

.location {
  display: inline-block;
  margin: 12px 0 0 0;
}
.location li {
  font-size: 14px;
  list-style: none;
}

.title span.branch-name {
  margin-top: 0px; 
  font-size:16px; 
  font-weight:600; 
  max-width: calc(100% - 120px);
  height: 43px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.treatment-title{
  font-size: 14px;
}

.close {
  color: rgba(0, 0, 0, 0.25) !important;
}

.close:hover {
  color: rgba(0, 0, 0, 1) !important;
}
agreebox {
  font-size: 12px;
}

@keyframes v-list-item--active {
  0% {
    color: #1976d2;
  }
  49% {
    color: #1976d2;
  }
  60% {
    color: transparent;
  }
  99% {
    color: transparent;
  }
  100% {
    color: #1976d2;
  }
}

@media screen and (max-width: 680px) {
  .modal-button-cancel {
    margin: 5px 15px 0 0 !important;
  }
  .modal-button-next {
    padding: 14px 25px 14px 10px !important;
  }

  .poweredby {
    width: 108px;
    padding-right: 6px;
  }

  .stickySteps {
    /* position: fixed; */
    background: #fff;
    height: 120px;
    top: 100;
    width: 100%;
    z-index: 900;
    padding: 0px 0 42px 0;
  }

  .stickyTitle {
    /* position: fixed; */
    background: #fff;
    height: 60px;
    top: 60;
    width: 100%;
    z-index: 900;
  }
}

</style>

<style>
span.v-stepper__step__step {
  min-height: 24px !important;
  min-width: 24px !important;
}
</style>
